// Registro de cambios de configuración (autogestión §1.2 / §4.2, T-qtbl):
// la lectura paginada y la descarga CSV de core-api. Ambas rutas exigen
// quien administra la organización (requireOrgAdmin); el 403 llega como
// ApiError ADMIN_REQUIRED y la pantalla ya está detrás de la misma
// capacidad en App.tsx. El CSV se baja autenticado con requestDownload
// (lib/api/client.ts): `request()` descarta cuerpos que no son JSON.

import {
  configAuditListResponseSchema,
  type ConfigAuditListResponse,
  type ConfigAuditSection,
} from "@bitacorapro/api-types";
import { request, requestDownload, type BlobDownload } from "../client";

export type ConfigAuditListParams = {
  /** Sin sección = todo el registro. */
  section?: ConfigAuditSection | undefined;
  /** El `nextCursor` de la página anterior, opaco, tal cual llegó. */
  cursor?: string | undefined;
  /** 1..200; el servidor usa 50 si no va. */
  limit?: number | undefined;
};

function search(params: Record<string, string | number | undefined>): string {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined) qs.set(k, String(v));
  }
  const s = qs.toString();
  return s ? `?${s}` : "";
}

export const configAuditApi = {
  // GET /organizations/me/config-audit?section=&cursor=&limit=
  list: async (params: ConfigAuditListParams = {}): Promise<ConfigAuditListResponse> => {
    const json = await request<unknown>(
      "GET",
      "core",
      `/organizations/me/config-audit${search({
        section: params.section,
        cursor: params.cursor,
        limit: params.limit,
      })}`
    );
    return configAuditListResponseSchema.parse(json);
  },
  // GET /organizations/me/config-audit.csv?section= — text/csv con BOM y
  // Content-Disposition attachment; el nombre del servidor viene en
  // `filename`.
  csv: (section?: ConfigAuditSection): Promise<BlobDownload> =>
    requestDownload("GET", "core", `/organizations/me/config-audit.csv${search({ section })}`),
};
